
<template>
  <div
    class="footer-content"
    :class="schemaFooter.settings.backgroundColor"
    :style="footerStyles"
  >
    <div class="footer-content__wrapper" :style="footerStyles">
      <div class="footer-content__wrapper-inner">
        <!-- disabling the buble by commenting -->
        <!-- <div class="marketing__fixed-quiz"  v-if="bubbleVisible">
          <img src="https://cdn.shopify.com/s/files/1/0558/8094/1760/files/close-button-white.svg?v=1669066929" @click="bubbleVisible=false" class="marketing__close" ></img>
          <div class="marketing__fixed-content" @click="launchQuiz">
            <p class="marketing__first-content">Unsure?</p>
            <p class="marketing__cta">Take the</p>
            <p class="marketing__cta">Skin Quiz</p>
          </div>
        </div> -->
        <!-- removed headline
        <div class="footer-content__headline">
          <span>{{schemaFooter.settings.headline1}}</span>
          <span v-if="schemaFooter.settings.headline2"><br />{{schemaFooter.settings.headline2}}</span>
        </div>
        -->
        <div class="footer-content__main-wrapper">
          <div class="footer-content__main-container container">
            <footer-contact-social v-if="!schemaContact.settings.hideContact" :schema="schemaContact" />
            <footer-email-collection v-if="!schemaEmail.settings.hideEmail" :schema="schemaEmail">
              <slot></slot>
            </footer-email-collection>
          </div>
        </div>
        <footer-main :schema="schemaMain" :schemaFooter="schemaFooter"></footer-main>

      </div>
    </div>
    <footer-sub-footer :schema="schemaSubfooter" :style="footerStyles" />
    <footer-to-top text="Top" :dynamicallyHide="true" :threshold="300" />
  </div>
</template>

<script>
import FooterEmailCollection from '@/scripts/components/footer/FooterEmailCollection.vue';
import FooterMain from '@/scripts/components/footer/FooterMain.vue';
import FooterContactSocial from '@/scripts/components/footer/FooterContactSocial.vue';
import FooterSubFooter from '@/scripts/components/footer/FooterSubFooter.vue';
import FooterToTop from '@/scripts/components/navigation/FooterToTop.vue';
import { mapState } from 'vuex';
import Icon from '@/scripts/components/basic/Icon.vue'

export default {
  name: 'FooterDefault',
  components: {
    FooterEmailCollection,
    FooterMain,
    FooterContactSocial,
    FooterSubFooter,
    FooterToTop,
    Icon
  },
  props: {
    schemaFooter: Object,
    schemaEmail: Object,
    schemaMain: Object,
    schemaContact: Object,
    schemaSubfooter: Object,
    footerAlign: {
      type: String,
      default: 'left',
    },
  },
  computed: {
    ...mapState({
      totalPrice: state => state.cart.checkout.total_price
    }),
    normalizedTotalPrice () {
       return parseFloat(this.totalPrice / 100) ;
    },
    footerStyles() {
      if (this.schemaFooter.settings.backgroundImage) {
        return {
          'background-image': `url(${this.schemaFooter.settings.backgroundImage})`,
        }
      }else {
        return {
          'background-color': this.schemaFooter.settings.backgroundColor,
        }
      }
    },
  },
  methods: {
    launchQuiz () {
      window.location.href="https://quiz.shikobeauty.com/mtcforvr";
    },
    close(){
      return this.bubbleVisible=false;
    },
    openPopup(){
      if (!this.excludePages.find(page => page.toUpperCase() == this.currentPage.toUpperCase())){
        if(this.normalizedTotalPrice>=60 ){
         this.timerId =  setTimeout(()=>{
          window._klOnsite = window._klOnsite || [];
          if (this.$mq !== 'mobile') {
            window._klOnsite.push(['openForm', this.klaviyoDesktopFormId]);
          }else {
            window._klOnsite.push(['openForm', this.klaviyoMobileFormId]);
          }
          sessionStorage.setItem("popupshowed", "true");
          },8000)
        } 
      } 
    }
  },
  mounted() {
    /*
    •ChatBubble
      - Cart Value: equal to 0
      - Page types exclude: Blogs, About us, Rewards, Registration, Login, Checkout, Confirmation
      - Page depth: Greater than 4, No PDP
      - On inactivity: After 30 seconds
    */
    if(localStorage.getItem('url')) {
      this.pages = JSON.parse(localStorage.getItem('url'));// pages are assigned from local storages
      let currentPage =window.location.href;
      let found= this.pages.find(value=> value==currentPage)
      if(found && this.pages.length>0 ){ 
        found = this.pages[this.pages.length-1] == currentPage
      }
      
      if (!found) { 
        this.pages.push(window.location.href)
        localStorage.setItem('url',JSON.stringify(this.pages));
      }
    } else {
      this.pages.push(window.location.href);
      localStorage.setItem('url',JSON.stringify(this.pages));
    }
     
    
    if ( this.pages &&  this.pages.map(url=> url.includes("/products/")).filter(x=>x ==true).length==0) {
      if (!this.excludePagesBubble.find(page => page.toUpperCase() == this.currentPage.toUpperCase()) && !this.currentPage.includes("/blogs")){
         var dataLayer = window.dataLayer || [];
              // Push the data to the dataLayer
        this.timerId = setTimeout(() => { 
          if (this.schemaFooter.settings.pageTemplate == "product"){
            this.bubbleVisible= (this.totalPrice <=0 && this.pages.length >4 && this.pages.filter(url=> url == window.location.href).length==1)
          }else {
            this.bubbleVisible= (this.totalPrice <=0 && this.pages.length >4)
            if (this.bubbleVisible==true){
              // Create a data object // Get the GTM dataLayer
              var dataLayer = window.dataLayer || [];
              // Push the data to the dataLayer
              dataLayer.push({"event":"gtm.elementVisibility"})
            }
          }
        }, 30000)
      }else {
        clearTimeout(this.timerId);
      } 
    }
    
    window.addEventListener("mousemove", (e) => {
      var scroll = window.pageYOffset || document.documentElement.scrollTop;
      var stb_exitintent = sessionStorage.getItem("popupshowed")==null?"false":"true";
        if((e.pageY - scroll) < 100 && stb_exitintent!="true" ) {
          this.showPopup = true;
        }else {
          this.showPopup = false; 
        }
     }); 
   
  },
  data() {
    return {
      excludePagesBubble: ["/blogs/all", "/pages/about-us", "/account/login", "/account/register", "/pages/rewards"],
      bubbleVisible: false,
      pages:[],
      pageDepth:0,
      timerId: null,
      currentPage: window.location.pathname,
      excludePages: ["/account/login", "/account/register", "/pages/rewards", "/pages/beauty-expert"],
      showPopup: false,
      klaviyoDesktopFormId:this.schemaFooter.settings.klaviyoDesktopFormId,
      klaviyoMobileFormId:this.schemaFooter.settings.klaviyoMobileFormId
    };
  },
  watch:{ 
    showPopup(){
      if( this.showPopup==true && window.bvaccel.b2b == false ) {
        this.openPopup();
        
      }else {
        clearTimeout(this.timerId);
      }
    }
  }
};
</script>

<style lang="scss">
.marketing{
  &__fixed-quiz{
    
    width: 12%;
    border-radius: 50%;
    background: linear-gradient(163deg, #9c9d77, #22231e);
    box-shadow: 4px 5px 6px 1px #0b10139c;
    line-height: 0;
    position: fixed;
    bottom: 50px;
    right: 20px;
    z-index: 30;
    display: flex;  
    cursor: pointer;
    
    &::after{
      content: "";
      display: block;
      padding-bottom: 100%;
    }
    @include mobile-only {
      width:  45%;
    }
    @include tablet-only {
      width: 23%;
    }
    
  }
  &__close{
    position: absolute;
    right: 15px;
    z-index: 3;
    width: 15%;
  }
  &__fixed-content{
    position: relative;
    width: 100%;
    text-align: center;
    display: flex;
    color: white;
    font-family: arial, sans-serif;
    font-weight: bold;
    flex-direction: column;
    justify-content: center;
    align-content: center;

    p {
      line-height: 1.5em;
      
    }
  }
  &__first-content{
    font-size: 22px;
    font-weight: normal;
    font-family: 'Avenir Book', sans-serif;
     
  }
  &__cta{
    font-family: 'Ginkgo-Light';
    font-size: 1.4rem;
    text-transform: none;
     
  }
  
}
.footer-content {
  overflow: hidden;

  &__wrapper {
    width: 100%;
  }
  &__wrapper-inner {
    max-width: 1243px;
    display: flex;
    margin: 0 auto;
    padding-top: 64px;
    flex-direction: column;

    @include tablet-up {
      padding: 40px 0 10px 0px;
      flex-direction: row;
    }

    @include mobile-only {
      padding-top: 32px;
    }
  }
  &__main-wrapper {
    position: relative;
    color: $color-white;
    flex: 2;

    @include mobile-only {
      min-height: 0;
      padding-bottom: 40px;
    }

    @include hd-up {
      margin-left: 0px;
    }
  }
  &__main-container {
    max-width: 1272px;
    display: flex;
    justify-content: space-between;

    @include mobile-tablet {
      flex-direction: column;
    }

    @include mobile-only {
      padding-top: 0;
    }
  }

  &__headline {
    font-size: rem(42);
    line-height: rem(48);
    font-family: $font-family-primary;
    color: $color-white-tea-300;
    text-transform: uppercase;
    text-align: center;
    padding: 0 20px 64px;

    span {
      white-space: nowrap;
    }

    @include tablet-up {
      font-size: rem(28);
      line-height: rem(34);
      text-align: left;
      max-width: 300px;
      padding-bottom: 0;
    }

    @include desktop-up {
      font-size: rem(56);
      line-height: rem(73);
      max-width: 440px;
      text-align: left;
    }
  }
}
.container {
  @include tablet-only {
    padding-left: 18px;
    padding-right: 18px;
  }
}
</style>
